// Alpine.js
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse';

// Alpine.js Components
import app from "./alpine/app.js";
import nav from "./alpine/nav.js";
import geo from "./alpine/geo.js";

// Initialize Alpine...
window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.data("app", app);
Alpine.data("nav", nav);
Alpine.data("geo", geo);
Alpine.start()

// Barba.js
require('./barba')

